import Vue from "vue";
import Vuex from "vuex";
import httpService from "@/utils/service";
import COVER from "@/utils/COVER";
import COVERAPP from "@/utils/COVERAPP";
import {shareTitle, getLocationPoint, getBaiduLocation} from "@/utils/utils";
import {
    getNotice,
    getRelate,
    queryChat,
    userLog,
    setUser,
    setPosition,
    queryComment,
    discussNews,
    discussNewsOther,
    getHotTopic,
    getHotTopicDesc,
    getHotTopicNews,
    getHotNews,
    getSceneCommon,
    queryMultiProgress,
    queryPoke,
    getSceneMultiProcess,
    queryTourism,
    queryTourSight,
    queryTourDetail,
    queryTourGo,
    queryTourCommon
} from "@/api/data";
import {tourData, recomData, clickBtn, selectArea, noInter} from "@/utils/demo";

const share = shareTitle();
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // aid: process.env.VUE_APP_ENV == "test" ? "5d90661929dcaa0b2d6ce760" : "5e69b4d1877710001edb7cb2", //活动id
        isApp: false, //是否在app中
        versionSize: 0, //app版本
        serverTime: 0, // 服务器时间
        userinfo: {}, //用户信息
        shareData: { //分享信息
            title: share.title,
            desc: share.desc,
            imgUrl: "https://wapcdn.thecover.cn/wap/2.3.4/share_logo.png",
            link: window.location.origin + window.location.pathname
        },
        isImmerse: false, //是否沉浸式
        device: COVERAPP.Attribute.isIOS() ? "ios" : "android",
        maskData: null, //弹框信息
        globalDuration: 0,
        chatLoading: false,
        maskShowStatus: false,
        homeChat: [],
        noticeList: [],
        toastList: [],
        linkSrc: "",
        isClearTimer: true,
        view11Tips: "",  //解决ios11布局问题,
        toastContent: {toastType: 0, list: {name: "", content: ""}},   // toastType:0 内容多提示类  1:选择地点类 选择价格类  2.选择景点类型类 3.导航 4.地点介绍   5.附近美食  6.附近景点  list:{}  name 左上角名称 content:''  or [],
        isToastShow: false,
        readNewsId: "",
        isOpenChat: false, //开启聊新闻模式,
        isInputShow: true,
        isClearInitTimer: false,  //该变量用来设置用户默认信息 如果未得到授权,
        newsContent: {},
        questionTips: "",
        guideTips: "",
        isViewFade: false,
        isTourShow: false,

        selectList: [],
        tourSelectData: [],

        tagsList: [],
        tourSelectType:''

    },
    mutations: {
        // 设置是否在app中
        appFlag(state, flag) {
            state.isApp = flag;
        },
        setVersionSize(state, num) {
            state.versionSize = num;
        },
        setServerTime(state, time) {
            state.serverTime = time;
        },
        setToastData(state, data) {
            state.toastData = data;
        },
        setPageLoading(state, flag) {
            state.pageLoading = flag;
        },
        setIsImmerse(state, flag) {
            state.isImmerse = flag;
        },

        // 设置用户信息
        getUserinfo(state, data) {
            state.userinfo = data;
        },
        // 设置分享数据
        setshareData(state, data) {
            state.shareData = data;
        },
        // 设置弹窗数据
        setMaskData(state, data) {
            state.maskData = data;
        },
        // 设置获得红包弹窗是否显示
        sethbFlagData(state, data) {
            state.hbFlagData = data;
        },
        // 设置结果页数据
        setResultData(state, data) {
            state.resultData = data;
        },


        /*我的*/
        setViewFade(state, data) {
            if (!data) {
                state.isViewFade = data;
            } else {
                setTimeout(() => {
                    state.isViewFade = data;
                }, 300);
            }

        },


        setHomeData(state, data) {
            state.homeChat = data;
        },
        setNoticeData(state, data) {
            state.noticeList = data;
            state.maskShowStatus = false;
        },
        setToastList(state, data) {
            state.toastList = data;
            state.maskShowStatus = false;
        },
        setGuideTips(state, data) {
            state.guideTips = data;
        },
        contactDisData(state, data) {
            state.homeChat = [];
            if (data.length == 1 && data[0].content.right) {
                state.questionTips = data[0].content.tips;
            } else {
                let count = 0;
                if (!data[0].content.right) {

                    if (data[0].content.view == 100) {
                        state.guideTips = data[count].content.tips;
                    }
                    if (data[0].content.view !== 100) {
                        state.guideTips = "";
                    }
                    if (data[data.length - 1].content.view == 101) {
                        state.isTourShow = true;
                        setTimeout(()=>{ state.isClearTimer = true;},0)
                        state.tourSelectType=data[data.length - 1].content.list.value;
                    }
                    if (data[data.length - 1].content.view !== 101) {
                        state.isTourShow = false;
                        // state.isInputShow = false;
                        state.tourSelectType='';
                    }
                    state.homeChat = [...state.homeChat, ...data];

                    setTimeout(() => {
                        state.maskShowStatus = false;
                        state.isViewFade = true;
                        httpService.pageScrollTo();
                    }, 0);
                }
            }


        },
        removeSyncLeftData(state, data) {
            // state.homeChat
        },
        //聊新闻使用
        chatDisData(state, data) {
            if (data.isClear) {
                state.homeChat = [];
            }
        },

        setLinkSrc(state, data) {
            state.linkSrc = data;
        },
        setGlobalDuration(state, data) {
            state.globalDuration = data;
        },
        setChatLoading(state, data) {
            state.chatLoading = data;
        },
        setClearTimer(state, data) {
            state.isClearTimer = data;
        },
        setToastContent(state, data) {
            state.toastContent = data;
        },
        setToastShow(state, data) {
            state.isToastShow = data;
        },
        setReadNewsId(state, data) {
            state.readNewsId = data;
        },
        setOpenChat(state, data) {
            state.isOpenChat = data;
        },
        setInputShow(state, data) {
            if (data) {
                // state.isTourShow = false;
                // state.tagsList = [];
                // state.tourSelectData = [];
            }
            state.isInputShow = data;
        },
        setTourShow(state, data) {
            state.isTourShow = data;
        },
        setInitTimer(state, data) {
            state.isClearInitTimer = data;
        },
        setNewsContent(state, data) {
            state.newsContent = data;
        },
        setMaskShowStatus(state, data) {
            state.maskShowStatus = data;
        },
        setSelectList(state, data) {
            state.selectList = data;
        },
        setTourSelectData(state, data) {
            state.tourSelectData = data;
        },
        setTagsList(state, data) {
            if (data.length) {
                const list = state.tagsList;
                if (list.some((item) => {
                    return item.name === data[0].name;
                })) {
                    list.splice(list.findIndex(v => v.name === data[0].name), 1);
                } else {
                    state.tagsList = [...new Set([...state.tagsList, ...data])];
                }
            } else {
                /*当传进来的为[]时重置*/
                state.tagsList = [];
            }
        },
        setSingleTags(state, data) {
            const list = state.tagsList;
            if (data.length) {
                if (list.some((item) => {
                    return item.name === data[0].name;
                })) {
                    list.splice(list.findIndex(v => v.name === data[0].name), 1);
                } else {
                    list.splice(list.findIndex(v => v.name.indexOf("km") > 0), 1);
                    state.tagsList = [...new Set([...state.tagsList, ...data])];
                }
            }
        }
    },
    actions: {
        // 设置是否在app中
        appFlagAsync({commit, state}, flag) {
            commit("appFlag", flag);
        },
        setVersionSizeAsync({commit, state}, num) {
            commit("setVersionSize", num);
        },
        setServerTimeAsync({commit, state}, time) {
            commit("setServerTime", time);
        },

        // 获取用户信息
        getUserInfoAsync({dispatch, commit, state}) {
            console.log('登录');
            COVER.getUser((ret) => {
                // setTimeout(()=>{   commit("setInitTimer",true)},100)
                const userinfo = JSON.parse(JSON.stringify(ret));
                if (COVERAPP.Attribute.isIOS() && userinfo.token) {
                    if (parseInt(state.versionSize) >= 450) {
                        userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
                    }
                }
                userLog({position: "store拿到返回", ...ret});

                commit("getUserinfo", userinfo);

                setUser(userinfo).then((res) => {
                    const {data: {data}} = res;
                    sessionStorage.setItem("USER_ID", data.id);
                    // cio.setUser(data.id,  ret.nickname, {userInfo: JSON.stringify(ret)});
                    const id = sessionStorage.getItem("USER_ID");
                    if (id || state.userinfo.id) {
                        commit("setInitTimer", true);
                        commit("chatDisData", {isClear: []});
                        dispatch("fetchHome", {payload: {question: ""}}).then(() => {
                            commit("setClearTimer", false);
                        });
                        dispatch("fetchNotice");
                        // getLocationPoint().then((res) => {
                        //     setPosition(res);
                        // });
                        getBaiduLocation();
                    }

                });
                // userLog(JSON.parse(JSON.stringify(res)))
            });

        },
        // 设置分享数据
        setshareDataAsync({commit, state}, data) {
            commit("setshareData", data);
        },
        // 设置弹窗数据
        setMaskDataAsync({commit, state}, data) {
            commit("setMaskData", data);
        },
        setToastDataAsync({commit, state}, data) {
            commit("setToastData", data);
        },
        setPageLoadingAsync({commit, state}, flag) {
            commit("setPageLoading", flag);
        },
        setIsImmerseAsync({commit, state}, flag) {
            commit("setIsImmerse", flag);
        },
        /*这设置用户信息*/
        setNoInfo({dispatch, state, commit}) {

            const userinfo = {origin: "yk", sessionId: COVER.uuid("uid")};
            commit("getUserinfo", userinfo);
            return new Promise((resolve, reject) => {
                try {
                    setUser(userinfo).then((res) => {
                        const {data: {data}} = res;
                        sessionStorage.setItem("USER_ID", data.id);
                        const id = sessionStorage.getItem("USER_ID");

                        if (id || state.userinfo.id) {
                            commit("chatDisData", {isClear: []});
                            dispatch("fetchHome", {payload: {question: ""}}).then(() => {
                                commit("setClearTimer", false);
                            });
                            dispatch("fetchNotice");
                            getBaiduLocation();
                            // getLocationPoint().then((res) => {
                            //     setPosition(res);
                            // });
                        }

                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        /*我的逻辑*/
        //首页
        fetchHome({state, commit}, {payload}) {
            commit("setInputShow", true);
            commit("setOpenChat", false);
            return new Promise((resolve, reject) => {
                try {
                    queryChat(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        if(!(payload.hasClearTimer)){
                            commit("setClearTimer", false);
                        }
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //请求question接口不拿返回数据
        fetchHomeNoData({state, commit}, {payload}) {
            commit("setInputShow", true);
            commit("setOpenChat", false);
            return new Promise((resolve, reject) => {
                try {
                    queryChat(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setGlobalDuration", 0);
                        if(!(payload.hasClearTimer)){
                            commit("setClearTimer", false);
                        }
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*戳一戳*/
        queryPoke({state, commit}) {
            commit("setInputShow", true);
            commit("setOpenChat", false);
            cio.track(3, "click", "pock");
            return new Promise((resolve, reject) => {
                try {
                    queryPoke().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },


        //多流程
        queryMultiProgress({state, commit}, {payload}) {
            commit("setInputShow", false);
            commit("setOpenChat", false);
            return new Promise((resolve, reject) => {
                try {
                    queryMultiProgress(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        //相关问题
        fetchRelate({commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    getRelate(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setToastList", data);
                        // commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        //提示栏
        fetchNotice({commit}) {
            getNotice().then((res) => {
                const {data} = res.data;
                commit("setNoticeData", data);
            });
        },

        //聊新闻
        queryComment({commit}, {payload}) {
            commit("setInputShow", false);
            commit("setChatLoading", true);
            commit("setTourShow",false)
            return new Promise((resolve, reject) => {
                try {
                    queryComment(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setClearTimer", true);
                        commit("setChatLoading", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        discussNews({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    discussNews(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        commit("setOpenChat", false);

                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        discussNewsOther({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    discussNewsOther(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopic({state, commit}) {
            commit("setInputShow", true);
            commit("contactDisData", [{content: {right: true, tips: ""}}]);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopic().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        // commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopicDesc({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopicDesc(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopicNews({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopicNews(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotNews({state, commit}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotNews().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        commit("setOpenChat", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getSceneCommon({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    getSceneCommon().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getSceneMultiProcess({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    getSceneMultiProcess().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*旅游场景--------------------*/
        queryTourism({state, commit}) {

            return new Promise((resolve, reject) => {
                try {
                    queryTourism().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setSelectList", data);
                        // commit("setTourShow", true);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getTourData({state, commit}, {payload}) {
            commit("setInputShow", false);
            const tags = [];

            const {tagsList} = state;
            tagsList.map((item) => {
                tags.push(item.name);
            });

            return new Promise((resolve, reject) => {
                try {
                    queryTourSight({ tags}).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", true);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*根据景点ID请求景点详情*/
        getTourInfo({state, commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    queryTourDetail(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", false);
                        commit("setClearTimer", true);
                        commit("setInputShow", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*我想去这里玩*/
        getWantToInfo({state, commit}, {payload}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    queryTourGo(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", false);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        /*不感兴趣*/
        getTourCommon({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    queryTourCommon().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    modules: {}
});
